import { useEffect, useState } from "react";

export function MetricBar({ label, value }: { label: string; value: number }) {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    // Small delay to allow the initial 0 width to render before transitioning
    const timer = setTimeout(() => {
      setWidth(value);
    }, 50);
    return () => clearTimeout(timer);
  }, [value]);

  return (
    <div data-testid={`metric-bar-${label.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="mb-2 flex items-center justify-between text-sm">
        <span className="font-medium text-stone-700">{label}</span>
        <span className="text-stone-500">{value}%</span>
      </div>
      <div className="h-2 overflow-hidden rounded-full bg-stone-100">
        <div 
          className="h-full rounded-full bg-stone-800 transition-all duration-1000 ease-out" 
          style={{ width: `${width}%` }} 
        />
      </div>
    </div>
  );
}
